import {CookieConsentValueChangedESB} from "@next/eventservice"
import Cookies from "js-cookie"
import {BR_SEARCH_VARIANT_COOKIE_NAME, RECENT_SEARCHES_COOKIE, MASID_COOKIE_NAME} from "../../config/constants"

const changedESB = new CookieConsentValueChangedESB()

export interface cookieRemoveDetails {
    name: string
    domain?: string
}
declare global {
    interface Window {
        cloudHeader: any
    }
}

export const cookiesToBeRemoved: cookieRemoveDetails[] = [
    {name: RECENT_SEARCHES_COOKIE},
    {name: BR_SEARCH_VARIANT_COOKIE_NAME},
    {name: MASID_COOKIE_NAME},
]

export const SubscribeCookieConsentValueChanged = (siteurl: string) => {
    return changedESB.subscribe(data => {
        handleSubcribe(siteurl, data)
    })
}

export const handleSubcribe = (siteUrl: string, consentEnabled: boolean) => {
    const cloudHeaderConfig = window.cloudHeader || {}
    window.cloudHeader = {...cloudHeaderConfig, cookieConsent: consentEnabled} as any
    if (!consentEnabled) {
        removeCookies(cookiesToBeRemoved)
    }
}

export const removeCookies = (cookieArray: cookieRemoveDetails[]) => {
    cookieArray.forEach(cookie => {
        const {name, domain} = cookie
        if (domain) Cookies.remove(name, {domain})
        else Cookies.remove(name)
    })
}
